import { BigTextInput, FieldShell, YesNoToggle } from './FieldPrimitives';

const PCPSection = ({ responses, setField }) => {
  const isFemale = responses.gender === 'female';
  return (
    <div className="space-y-6">
      <p className="text-base md:text-lg text-gray-700">
        A few last questions before we move on to consent.
      </p>

      <FieldShell label="Do you have a primary care provider (PCP)?">
        <YesNoToggle
          value={responses.has_pcp}
          onChange={(v) => setField('has_pcp', v)}
        />
      </FieldShell>

      {responses.has_pcp === true && (
        <FieldShell
          label="Primary care provider name"
          htmlFor="pcp_name"
          help="Example: Dr. Susan Smith."
        >
          <BigTextInput
            id="pcp_name"
            value={responses.pcp_name}
            onChange={(v) => setField('pcp_name', v)}
            maxLength={120}
          />
        </FieldShell>
      )}

      <FieldShell
        label="When did you last see a doctor or specialist about your condition?"
        htmlFor="last_pcp_visit"
        help="Approximate is fine. Example: 'March 2025' or '6 months ago'."
      >
        <BigTextInput
          id="last_pcp_visit"
          value={responses.last_pcp_visit}
          onChange={(v) => setField('last_pcp_visit', v)}
          maxLength={120}
        />
      </FieldShell>

      <FieldShell label="Are you renewing an existing certification?">
        <YesNoToggle
          value={responses.is_renewal}
          onChange={(v) => setField('is_renewal', v)}
        />
      </FieldShell>

      {isFemale && (
        <>
          <FieldShell label="Are you currently pregnant?">
            <YesNoToggle
              value={responses.pregnant}
              onChange={(v) => setField('pregnant', v)}
            />
          </FieldShell>
          <FieldShell label="Are you currently breastfeeding?">
            <YesNoToggle
              value={responses.breastfeeding}
              onChange={(v) => setField('breastfeeding', v)}
            />
          </FieldShell>
        </>
      )}
    </div>
  );
};

export default PCPSection;
